"use client";

import { Price } from "@repo/components/atoms/price";
import { cn } from "@repo/lib";
import { useCartQuery } from "#/hooks/shopify";

export function TotalAmount({
  className,
  lang,
}: {
  className?: string;
  lang: Navigator["language"];
}) {
  const cart = useCartQuery();

  const totalAmount = cart?.cost?.totalAmount;

  if (!totalAmount) {
    return null;
  }

  return (
    <Price
      {...totalAmount}
      aria-live="polite"
      className={cn(
        "absolute mt-2 p-1 bg-accent text-accent-foreground opacity-0 pointer-events-none text-xs",
        "group-focus-within:opacity-100 group-hover:opacity-100",
        {
          "opacity-0": !totalAmount,
        },
        className,
      )}
      lang={lang}
      role="status"
      style={{
        /* @ts-expect-error: CSS Anchor Positioning API not currently typed */
        positionAnchor: "--anchor-open-cart",
        insetBlockStart: "anchor(bottom)",
        insetInlineEnd: "anchor(right)",
      }}
    />
  );
}
